const createConfigDependencies = ({ config }) => {
    return [
        {
            definition: {
                id: 'config',
                type: 'config',
                factory: () => config,
            },
        },
    ];
};
export default createConfigDependencies;
